import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import { loadHeavyStompunkterIfNeeded } from './loadHeavyStompunkter'

export const changePage = createActionCreator(actions.CHANGE_PAGE, 'page')

export const closePage = createActionCreator(actions.CLOSE_PAGE)

export const addOverlayPage = createActionCreator(actions.ADD_OVERLAY_PAGE, 'page')

export const viewStompunkt = createActionCreator(actions.VIEW_STOMPUNKT, 'id', 'reason')

export const clearStompunkt = createActionCreator(actions.CLEAR_STOMPUNKT)

export function openStompunkt(id, reason) {
	return function(dispatch, getState) {
		dispatch(loadHeavyStompunkterIfNeeded([id]))
		dispatch(viewStompunkt(id, reason))
	}
}

export function navigateToUrlFragment() {
	const urlFragment = window.location.hash.substring(1)
	window.location.hash = ""
	return urlFragment
		? openStompunkt(urlFragment, "url")
		: doNothing
}

const doNothing = () => {}



// WEBPACK FOOTER //
// ./src/actionCreators/page.js